<template>
  <div v-if="role">
    <RoleHeader :title="role.name" />
    <div class="p-16 space-y-8">
      <RoleInfo :role="role" />
      <RolePermissions :role="role" />
    </div>
    <div>
      <RouterView name="modal" />
    </div>
  </div>
</template>

<script>
import { roleMethods, roleComputed } from '@/store/adminHelper';
import RoleHeader from '@/components/Roles/Header.vue';
import RoleInfo from '@/components/Roles/Info.vue';
import RolePermissions from '@/components/Roles/Permissions.vue';

export default {
  name: 'Role',
  components: {
    RoleHeader,
    RoleInfo,
    RolePermissions,
  },
  props: {
    roleId: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...roleComputed,
  },
  created() {
    const { roleId } = this;
    this.handleGetRole(roleId);
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...roleMethods,
    handleGetRole(roleId) {
      this.fetching = true;
      this.getRole({ roleId })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.$router.back();
          this.fetching = true;
        });
    },
  },
};
</script>
